<div class="container-fluid m-t-sm" *ngIf="isLoaded()">
  <!-- COLLAPSABLE -->
  <div class="row">
    <div class="col-12 m-b-md">
      <div class="titleElement"> Precios Unitarios (Ofertas)
      </div>
    </div>
    <div class="col-12 m-b-md">
      <p-panel [toggleable]="true" [collapsed]="false">
        <p-header>
          <span class="cif ml-2">Mostrando
            {{unitPriceRelationDocuments?.projectUnitPrice ?
            unitPriceRelationDocuments?.projectUnitPrice?.length :
            '0'}} de {{unitPriceRelationDocuments?.projectUnitPrice?.length}}</span>
        </p-header>
        <div class="row">
          <div class="col-12">
            <p-table [responsive]="true" [value]="unitPriceRelationDocuments.projectUnitPrice" [paginator]="false">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 80%" pSortableColumn="description">{{'General.description'|translate}}
                  </th>
                  <th style="width: 10%" pSortableColumn="date">{{'Fecha'|translate}}
                  </th>
                  <th class="text-right action-column-2"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-unitprice>
                <tr>
                  <td style="width: 80%"
                    [ngStyle]="{'background': unitprice?.document?.entity?.documentClass?.abbreviation === 'FE' ? 'lightgray' :  ''}">
                    <formatDataValue [type]="TEXT" [value]="unitprice.description?unitprice.description:'--'">
                    </formatDataValue>
                  </td>
                  <td style="width: 10%"
                    [ngStyle]="{'background': unitprice?.document?.entity?.documentClass?.abbreviation === 'FE' ? 'lightgray' :  ''}">
                    <span class="p-column-title">{{'Fecha'|translate}}</span>{{ unitprice.date |
                    date: 'dd/MM/yyyy'}}
                  </td>
                  <td class="text-right action-column-2"
                    [ngStyle]="{'background': unitprice?.document?.entity?.documentClass?.abbreviation === 'FE' ? 'lightgray' :  ''}">
                    <div class="float-right btn-group d-flex justify-content-end text-right">
                      <button class="btn btn-sm btn-secondary t-action-button" (click)="this.viewUnitPrice(unitprice)"
                        title="{{ 'Exportar' | translate}}">
                        <i class="far fa-file-excel" aria-hidden="true"></i>
                      </button>
                      <button class="btn btn-sm btn-secondary t-action-button" (click)="this.openDocument(unitprice)"
                        title="{{ 'General.view' | translate}}">
                        <i class="fas fa-eye" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr class="text-center">
                  <td colspan="3"><span>{{ 'General.noData' | translate }}</span></td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </div>
    <!-- arbol de divisiones -->
    <div class="col-12 m-b-md">
      <div class="titleElement"> Precios del Contrato
      </div>
      <!--</div>
    <div class="col-12 m-b-md">
      <formElement [model]="this" [fieldConfig]="getBuscadorDivisionTree()" (valueChanged)="changeDivision ()">
      </formElement>
    </div>-->

      <!--<div class="col-12 m-b-md">
    </div>-->

      <!-- **** PANEL DE PRECIOS UNITARIOS DE DIVISIONES DE ADJUDICACIONES
    <div class="col-12 m-b-md">-->
      <formPlyca #formPlycaRef1 [formConfig]="formConfig1" *ngIf="formConfig1" [manageWaitService]=false>
      </formPlyca>
      <p-panel [toggleable]="true" [collapsed]="false" [style]="'overflow-x:scroll'">
        <p-header>
          <span class="cif ml-2">Mostrando
            {{unitPriceRelationDocuments?.filterDivisionUnitPrice ?
            unitPriceRelationDocuments?.filterDivisionUnitPrice?.length :
            '0'}} de {{unitPriceRelationDocuments?.divisionUnitPrice?.length}}</span>
        </p-header>
        <div class="row">
          <div class="col-12">
            <p-table [responsive]="true" [value]="unitPriceRelationDocuments.filterDivisionUnitPrice"
              sortField="creationDate" sortOrder="1" [rows]="10" [paginator]="true" [pageLinks]="4"
              [rowsPerPageOptions]="[5, 10, 25, 50]">
              <ng-template pTemplate="header">
                <tr>
                  <th style="width: 80%" pSortableColumn="description">{{'General.description'|translate}} <p-sortIcon
                      field="description">
                    </p-sortIcon>
                  </th>
                  <th style="width: 10%" pSortableColumn="date">{{'Fecha'|translate}} <p-sortIcon
                      field="unitprice.date">
                    </p-sortIcon>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-unitprice>
                <tr>
                  <td style="width: 80%">
                    <formatDataValue [type]="TEXT" [value]="unitprice.description?unitprice.description:'--'">
                    </formatDataValue>
                  </td>
                  <td style="width: 10%"><span class="p-column-title">{{'General.name'|translate}}</span>{{
                    unitprice.date | date: 'dd/MM/yyyy' }}
                  </td>
                  <td class="text-right action-column-2">
                    <div class="float-right btn-group d-flex justify-content-end text-right">
                      <button class="btn btn-sm btn-secondary t-action-button" (click)="this.viewUnitPrice(unitprice)"
                        title="{{ 'Exportar' | translate}}">
                        <i class="far fa-file-excel" aria-hidden="true"></i>
                      </button>
                      <button class="btn btn-sm btn-secondary t-action-button" (click)="this.openDocument(unitprice)"
                        title="{{ 'General.view' | translate}}">
                        <i class="fas fa-eye" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr class="text-center">
                  <td colspan="3"><span>{{ 'General.noData' | translate }}</span></td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
</div>